/**
 * The 🧪 mark on a drop reserved for the experiment gateway — for whoever
 * may see experiments (admin-only unless granted).
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { useCanSeeExperiments } from './use-can-see-experiments';

export const ExperimentMark: FC = () =>
  useCanSeeExperiments() ? (
    <span className="text-primary" title="Reserved for the experiment gateway — compared with the pool's other gateways over the experiment's days (Gateways tab, Experiment).">
      🧪 experiment
    </span>
  ) : null;
